<!-- <input
  #inputElement
  [id]="inputId"
  [type]="showPassword ? 'text' : 'password'"
  [class]="class"
  (change)="writeValue($event.target.value)"
  [autocomplete]="autocomplete"
  [attr.aria-label]="ariaLabel"
/>
<i [class]="currentPasswordIcon" (click)="showPassword = !showPassword" role="button" tabindex="0"></i> -->

<div class="password-wrapper">
  <input
    #inputElement
    [id]="inputId"
    [type]="showPassword ? 'text' : 'password'"
    [class]="class"
    (change)="writeValue($event.target.value)"
    [autocomplete]="autocomplete"
    [attr.aria-label]="ariaLabel"
  />

  <button
    type="button"
    class="toggle-password-btn"
    (click)="showPassword = !showPassword"
    [attr.aria-label]="(showPassword ? 'wcag.password-input.hide' : 'wcag.password-input.show') | translate"
    [attr.aria-pressed]="showPassword"
  >
    <i [class]="currentPasswordIcon" aria-hidden="true"></i>
  </button>

  <span class="sr-only" aria-live="polite">
    {{ showPassword ? ('wcag.password-input.shown' | translate : { value: inputElement.value }) : ('wcag.password-input.hidden' | translate) }}
  </span>
</div>
